import { useCallback, useMemo, useRef, useState } from 'react';

import { useOnClickOutside } from '../../../hooks/useOnClickOutside';
import { CaretCircleUpIcon, CaretCircleDownIcon } from '../../icons';

export type UseToggleSelectProps = {
    hasNone: boolean;
    maxLetters?: number;
    emptySelection?: string;
    options: string[];
};

export function useToggleSelect({ hasNone, emptySelection, options, maxLetters }: UseToggleSelectProps) {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);

    const showEllipsis = typeof maxLetters !== 'undefined';

    const handleClick = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    useOnClickOutside(ref, () => {
        setIsOpen(false);
    });

    const CaretCircle = useMemo(() => {
        if (isOpen) {
            return CaretCircleUpIcon;
        }
        return CaretCircleDownIcon;
    }, [isOpen]);

    const dropdownOptions = useMemo(() => {
        if (hasNone && emptySelection) return [emptySelection, ...options];
        return options;
    }, [hasNone, options, emptySelection]);

    return { showEllipsis, handleClick, setIsOpen, isOpen, ref, dropdownOptions, CaretCircle };
}
